import { NextResponse } from 'next/server'
import { query, uuid } from '@/lib/db'

export async function POST(req: Request) {
  const { shop_id, user_id, caisse_session_id, categorie, montant, note, date } = await req.json()
  const id = uuid()
  await query(
    'INSERT INTO charges (id, shop_id, user_id, caisse_session_id, categorie, montant, note, date) VALUES (?, ?, ?, ?, ?, ?, ?, ?)',
    [id, shop_id, user_id, caisse_session_id || null, categorie, montant, note || null, date]
  )
  return NextResponse.json({ id })
}

export async function GET(req: Request) {
  const { searchParams } = new URL(req.url)
  const shopId = searchParams.get('shop_id')
  const from = searchParams.get('from')
  const to = searchParams.get('to')

  const charges = await query(
    'SELECT * FROM charges WHERE shop_id = ? AND date >= ? AND date <= ? ORDER BY created_at DESC',
    [shopId, from, to]
  )
  return NextResponse.json(charges)
}
